import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton, Tabs, Tab, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useDispatch, useSelector } from "react-redux";
import { PayslipTable as tableDef } from "../../../src/config/grid-columns-defs";
import { Link, useNavigate, useParams } from "react-router-dom";
import BetterControlledTable from "../../component/BetterControlledTable";
import TabPanel from "../../component/TabPanel";
import { deleteEmpPaySlipData, getPayslipList, updateValidationStatus } from "../../api/payslipApis";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

export default function PaySlipList() {
  const params = useParams();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [detailTabIndex, setDetailTabIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const[passId,setPassId]=useState();
  const onlistbyIdDelete = async (id) => {
    try {
      const { data } = await deleteEmpPaySlipData(id, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      setTableRefreshCount((prev) => prev + 1);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  
console.log(params?.data?.validation_status,"params?.data?.validation_status")
  if (obj === undefined)
    if (tableDef.length > 0) {
      tableDef.splice(0, 0, {
        headerName: "Action",
        field: "",
        minWidth: 150,
        resizable: true,
        headerClass: "justify-center",
        cellClass: "justify-center",

        cellRenderer: (params) => {
         
          return params?.data?.validation_status === "Pending" ? (
            <>
              <Link to={`/payslip-form/${params.data.id}`}>
                <IconButton title="View Details">
                  <NoteAltOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Link>

              <IconButton color="info" title="View Details">
                <VisibilityIcon fontSize="inherit" />
              </IconButton>
              <IconButton color="error" onClick={() => {setPassId(params?.data?.id);setOpen(true)}}>
                <DeleteIcon />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                color="info"
                title="View Details"
                style={{ left: "-19px" }}
              >
                <CheckCircleIcon color="success" fontSize="inherit" />
              </IconButton>

              <IconButton
                color="info"
                title="View Details"
                style={{ left: "-19px" }}
              >
                <VisibilityIcon fontSize="inherit" />
              </IconButton>
            </>
          );
        },
      });
      tableDef.splice(4, 0, {
        headerName: "Validation Status",
        field: "validation_status",
        minWidth: 150,
        resizable: true,
        headerClass: "justify-center",
        cellClass: "justify-center",
        cellRenderer: (params) => {
          return params?.data?.validation_status === "Pending" ? (
            <Button
              size="small"
              sx={{ borderRadius: "10px" }}
              variant="contained"
              color="error"
              // onClick={()=>handleValStatusConfirmation( params?.data?.id)}
              onClick={() =>  {setPassId(params?.data?.id) ;setOpenConfirm(true)}}
            >
              Update Status
            </Button>
          ) : (
            <Box sx={{ color: "green", fontSize: "15px" }}>  <Button
            size="small"
            sx={{ borderRadius: "10px" }}
            variant="contained"
            color="success"
          >
            apporved
          </Button></Box>
          );
        },
      });
    }
  // }

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        // navigate(`${dialogAction.data.emp_id}/${dialogAction.data.id}``);
        navigate(`${dialogAction.data.emp_id}`, {
          state: {
            resign_id: dialogAction?.data?.id,
            status: dialogAction?.data?.latest_status_details,
          },
        });
        break;
      default:
        break;
    }
  }, [dialogAction]);

  const updateTableValidationStatus = async (id) => {
    try {
      const { data } = await updateValidationStatus(id, user.token);
      dispatch(showAlert(data.msg));
      setOpenConfirm(false);
      setTableRefreshCount((prev) => prev + 1);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  const getRows = async (limit, offset) => {
    try {
      const { data } = await getPayslipList(
        {
          limit,
          offset,
        },
        user.token
      );

      return {
        rows: data.data.data,
        total: data?.data.total,
        error: false,
      };
    } catch (error) {
      // handleAxiosError(error, dispatch);
      return { error: true };
    }
  };
      // setPassId(params?.data?.id);
console.log(params?.data?.id,"iddd")
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            PaySlip
          </Typography>
        </Box>
        { (user?.department==="Hr"|| user?.department==="Finance" ) ?
        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Button
            size="medium"
            sx={{
              fontWeight:"bold",
              fontSize:"14px",
              borderRadius:"10px"
            }}
            onClick={() => {
              navigate("/Payslip-Form");
            }}
            variant="contained"
            color="info"
          
          >
            Create
          </Button>
        </Box>
        :null
}
      </Box>
      <br />
      <TabPanel value={detailTabIndex} index={0}>
        <div className="pmt-controll-table">
          <BetterControlledTable
            hasActionButtons={false}
            getTableRows={getRows}
            columns={tableDef}
            perPage={10}
            refreshCounter={tableRefreshCount}
          />
        </div>
      </TabPanel>
  
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
          <DialogContent style={{ width: "500px" }}>
            <DialogContentText id="alert-dialog-description">
              <p>Are you sure want to Delete?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className="cancel-button">
              Cancel
            </Button>
            <Button   onClick={() => onlistbyIdDelete(passId)} className="add-button btn-align-right">Confirm</Button>
          </DialogActions>
        </>
      </Dialog>

      <Dialog
        open={openConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <>
          <DialogTitle id="alert-dialog-title">Confirm Update</DialogTitle>
          <DialogContent style={{ width: "500px" }}>
            <DialogContentText id="alert-dialog-description">
              <p>Are you sure you want to update?</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirm(false);
              }}
              className="cancel-button"
            >
              Cancel
            </Button>
   \
           
          </DialogActions>
        </>
      </Dialog>
    </Box>
  );
}


